import './OnboardingFooter.scss';

export interface OnboardingFooterProps {
  children: React.ReactNode;
}
const OnboardingFooter = ({ children }: OnboardingFooterProps) => {
  return (
    <div className="Mfw-OnboardingPage-screen Mfw-OnboardingFooter-root">
      {children}
    </div>
  );
};

export default OnboardingFooter;
